import { render } from "./TurbineDetailView.vue?vue&type=template&id=6e0517ad&ts=true"
import script from "./TurbineDetailView.vue?vue&type=script&lang=ts"
export * from "./TurbineDetailView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__